import React, { FC } from "react";
import { Link } from "gatsby-theme-material-ui";
import { KeyboardArrowRightRounded } from "@mui/icons-material";

import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import { SxProps, Typography } from "@mui/material";

interface Props {
  url: string;
  color?: "string";
  sx?: SxProps;
  children: JSX.Element | string | undefined;
}

const BaseLink: FC<Props> = ({
  url,
  color = Colors.PrimaryMain,
  children,
  sx = {},
}) => {
  return (
    <Link href={url} underline="none">
      <Typography
        variant="body1"
        sx={{
          display: "flex",
          alignItems: "center",
          fontSize: "16px",
          lineHeight: "31px",
          fontWeight: "400",
          color: color,
          ...sx,
        }}
      >
        {children}
        <KeyboardArrowRightRounded sx={{ marginLeft: 0.5, fontSize: "20px" }} />
      </Typography>
    </Link>
  );
};

export default BaseLink;
